import styled from 'styled-components';
import { colors } from '~/styles/colors';

export const HealthMachineInfoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  text-align: left;
`;

export const HealthStatusContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  color: ${colors.text['main-900']}
`;

export const HealthStatusDescription = styled.p`
  font-weight: 400;
  font-size: 12px;
  line-height: 180%;
`;

export const HealthStatusTitle = styled.p`
  font-weight: 500;
  font-size: 16px;
  line-height: 130%;
  width: 100%;
`;

export const HealthStatusList = styled.ul`
  margin: 0;
  padding-left: 18px;
  li {
    list-style: disc;
    font-weight: 400;
    font-size: 12px;
    line-height: 180%;
    color: ${colors.text['main-900']};
  }
`;
